"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CashOutPaymentPlanType = exports.NoAmortizationTermsGeneratedReason = exports.AmortizationSource = void 0;
/**  @TranslateToPython  */
var AmortizationSource;
(function (AmortizationSource) {
    AmortizationSource["CASH_OUT"] = "CASH_OUT";
    AmortizationSource["CREDIT_CARD_BALANCE_TRANSFER"] = "CREDIT_CARD_BALANCE_TRANSFER";
    AmortizationSource["INTERNAL_PLAN_TRANSFER"] = "INTERNAL_PLAN_TRANSFER";
    AmortizationSource["AUTO_LOAN_REFINANCE"] = "AUTO_LOAN_REFINANCE";
    AmortizationSource["STATE_RECORDING_CHARGE"] = "STATE_RECORDING_CHARGE";
    AmortizationSource["SIGNING_CHARGE"] = "SIGNING_CHARGE";
    AmortizationSource["LOAN_CONVERSION"] = "LOAN_CONVERSION";
    AmortizationSource["HELOC_REFI_TRANSFER"] = "HELOC_REFI_TRANSFER";
    AmortizationSource["SIMPLE_INTEREST_LOAN_REMEDIATION"] = "SIMPLE_INTEREST_LOAN_REMEDIATION";
    // Balance sweep in MOFO, SuperCLI, or Defensive FMP.
    AmortizationSource["BALANCE_SWEEP"] = "BALANCE_SWEEP";
    AmortizationSource["CASH_OUT_UPFRONT_FOR_ACCOUNT_ACTIVATION"] = "CASH_OUT_UPFRONT_FOR_ACCOUNT_ACTIVATION";
    // Monthly payment calculation of SIPs in aven_frontend/aven/src/components/onboarding/MonthlyPaymentTableListItem.vue
    AmortizationSource["OG_MONTHLY_PAYMENT_CALCULATION_FOR_SIMPLE_INTEREST_LOAN"] = "OG_MONTHLY_PAYMENT_CALCULATION_FOR_SIMPLE_INTEREST_LOAN";
    AmortizationSource["OG_PQ_OFFER_INSTALLMENT_INFO"] = "OG_PQ_OFFER_INSTALLMENT_INFO";
    /** Upgrade path to convert UCC cardholders to Home cardholders */
    AmortizationSource["UCC_TO_HOME_UPGRADE_DRYRUN"] = "UCC_TO_HOME_UPGRADE_DRYRUN";
    AmortizationSource["ENGAGEMENT_FULL_DRAW"] = "ENGAGEMENT_FULL_DRAW";
    AmortizationSource["CASH_TO_MERCHANT"] = "CASH_TO_MERCHANT";
    /** Restricted-state merchant cash out: funds go to customer's bank, not merchant's */
    AmortizationSource["CASH_OUT_TO_MERCHANT"] = "CASH_OUT_TO_MERCHANT";
    /** Convert purchase transaction into fixed plan */
    AmortizationSource["PURCHASE_TXN_SWEEP"] = "PURCHASE_TXN_SWEEP";
    /** Home purchase wires precede CoreCard posting, which is backdated to the disbursement date after settlement confirmation.*/
    AmortizationSource["HOME_PURCHASE_SETTLEMENT"] = "HOME_PURCHASE_SETTLEMENT";
    AmortizationSource["FLEX_DEBT_SWAP_BALANCE_TRANSFER"] = "FLEX_DEBT_SWAP_BALANCE_TRANSFER";
    /** Home (loan application) cardholder paying off external tradelines selected during prequal via user-selected debt swap. */
    AmortizationSource["SLIDER_HOME_DEBT_SWAP_BALANCE_TRANSFER"] = "SLIDER_HOME_DEBT_SWAP_BALANCE_TRANSFER";
})(AmortizationSource || (exports.AmortizationSource = AmortizationSource = {}));
/** @TranslateToPython */
var NoAmortizationTermsGeneratedReason;
(function (NoAmortizationTermsGeneratedReason) {
    NoAmortizationTermsGeneratedReason["NONE"] = "NONE";
    NoAmortizationTermsGeneratedReason["HCM_LIMIT"] = "HCM_LIMIT";
    NoAmortizationTermsGeneratedReason["BREACH_DTI_LIMIT"] = "BREACH_DTI_LIMIT";
})(NoAmortizationTermsGeneratedReason || (exports.NoAmortizationTermsGeneratedReason = NoAmortizationTermsGeneratedReason = {}));
var CashOutPaymentPlanType;
(function (CashOutPaymentPlanType) {
    CashOutPaymentPlanType["REVOLVING"] = "revolving";
    CashOutPaymentPlanType["INSTALLMENT"] = "installment";
    CashOutPaymentPlanType["FIXED_INTEREST_ONLY"] = "fixedInterestOnly";
})(CashOutPaymentPlanType || (exports.CashOutPaymentPlanType = CashOutPaymentPlanType = {}));
